import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../_services/auth.service';
import { MerchantService } from '../_services/fundraising/merchant.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.loggedIn()
      .pipe(map(result => {
        if (!result) {
          console.log('You need to be logged in to access this area');
          this.authService.logout().subscribe(() => {
            this.router.navigate(['/login']);
          });
        }
        return result;
    }));
  }
}


@Injectable()
export class MerchantAuthGuard implements CanActivate {
  constructor(private merchantService: MerchantService, private router: Router) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.merchantService.loggedIn()
      .pipe(map(result => {
        if (!result) {
          console.log('You need to be logged in to access this area');
          this.merchantService.logout();
          this.router.navigate(['/merchant-login']);
        }
        return result;
    }));
  }
}
